import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Badge } from "@/components/ui/badge";
import { fmtDateTime } from "@/lib/format";
import { toast } from "sonner";

const ACTION_BADGE = {
  created: "bg-emerald-100 text-emerald-800", updated: "bg-blue-100 text-blue-800",
  deleted: "bg-red-100 text-red-800", imported: "bg-indigo-100 text-indigo-800",
  reversed: "bg-amber-100 text-amber-800", approved: "bg-emerald-100 text-emerald-800",
  rejected: "bg-slate-200 text-slate-600", changes_requested: "bg-amber-100 text-amber-800",
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit", { params: { limit: 300 } }).then(({ data }) => setLogs(data)).catch((e) => toast.error(apiError(e))); }, []);
  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Every create, edit, delete, import, reversal and approval — who did what and when." testid="audit-header" />
      <div className="bg-white border border-slate-200 rounded-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-200">
            <th className="py-3 px-4">Time</th><th className="py-3 px-4">User</th><th className="py-3 px-4">Action</th><th className="py-3 px-4">Entity</th><th className="py-3 px-4">Note</th>
          </tr></thead>
          <tbody>
            {logs.length === 0 ? <tr><td colSpan={5} className="text-center py-10 text-slate-400">No audit entries yet.</td></tr> :
              logs.map((l) => (
                <tr key={l.id} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`audit-row-${l.id}`}>
                  <td className="py-2.5 px-4 text-slate-500 whitespace-nowrap">{fmtDateTime(l.timestamp)}</td>
                  <td className="py-2.5 px-4">{l.user_name || "system"}</td>
                  <td className="py-2.5 px-4"><Badge className={ACTION_BADGE[l.action] || "bg-slate-100 text-slate-700"}>{l.action}</Badge></td>
                  <td className="py-2.5 px-4 text-slate-500">{l.entity}</td>
                  <td className="py-2.5 px-4 text-slate-500 text-xs max-w-md">{l.note || "—"}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
